export default {
  destincIcon: 'https://maps.google.com/mapfiles/ms/micons/red-dot.png',
  startcIcon: 'https://maps.google.com/mapfiles/ms/micons/green-dot.png',
  yellowIcon: 'https://maps.google.com/mapfiles/ms/micons/yellow-dot.png',
  blueIcon: 'https://maps.google.com/mapfiles/ms/micons/blue-dot.png',

  default: {
    coord: {
      lat: 22.321831,
      lng: 114.168375
    },
    zoom: 15,
    pointZoom: 18,
  },

  color: [
    'rgb(255, 0, 0)',
    'rgb(0, 255, 0)',
  ]
};
